<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <a-row style="margin-bottom:10px;">
      <a-col :span="8">
        <a-button type="primary" @click="createEvent(0)">添加供应商</a-button>
      </a-col>
      <a-col :span="8" :offset="8" class="right-box">
        <a-button @click="goRulesPage">同步规则</a-button>
      </a-col>
    </a-row>
    <search-page-view
      ref="table"
      rowKey="id"
      :columns="getColumns()"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <template slot='statusSlot' slot-scope="data">
        <span v-if='data.record.status==1'>启用</span>
        <span v-else>禁用</span>
      </template>
      <div slot="action" slot-scope="data">
        <a @click="createEvent(data.record.id)">编辑</a>
        <a-divider type="vertical"></a-divider>
        <span>
        <a v-if="data.record.status == 0" @click="handleEvent(data.record.id,1)">启用</a>
        <a v-else @click="handleEvent(data.record.id,0)">禁用</a>
      </span>
      </div>
    </search-page-view>
    <a-modal title="添加供应商" :visible="dialogVisible" width="550px" :footer="null" @cancel="handleCancel">
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="供应商名称" prop="supplierName">
          <a-input v-model.trim="ruleForm.supplierName" placeholder="请输入供应商名称" :maxLength="25"/>
        </a-form-model-item>
        <a-form-model-item label="appId" prop="appId">
          <a-input v-model.trim="ruleForm.appId" placeholder="请输入appId" :maxLength="250"/>
        </a-form-model-item>
        <a-form-model-item label="appKey" prop="appKey">
          <a-input v-model.trim="ruleForm.appKey" placeholder="请输入appKey" :maxLength="250"/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit('ruleForm')" :loading="submitLoading">提交</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'UbrAccount',
  components: {},
  data() {
    return {
      submitLoading: false,
      dialogVisible: false,
      popupVisible: false,
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      ruleForm: {
        supplierName: '',
        appId: '',
        appKey: '',
        id: '',
        merchantId: this.$store.getters.userInfo.merchantId,// 运营商ID ,
        platformId: this.getPlatformConfig().platformId
      },
      rules: {
        supplierName: [
          { required: true, message: '请输入供应商名称', trigger: 'blur' }
        ],
        appId: [
          { required: true, message: '请输入appId', trigger: 'blur' }
        ],
        appKey: [
          { required: true, message: '请输入appKey', trigger: 'blur' }
        ]
      },
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId

      },
      loadPromise: params => this.getListPromise(params)
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'UbrTicketPro', title: '商品绑定' },
      { name: 'UbrTicketOrder', title: '订单直连' },
      { name: 'UbrAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getServerApiService().post('ubr/getUBRAccountList', params)
    },
    handleCancel() {
      this.dialogVisible = false
      this.popupVisible = false
    },
    handleSubmit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.getLogUtils().logWithTag('添加供应商', form)
          this.submitSupplierData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    // 新增、编辑供应商信息
    submitSupplierData() {
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('ubr/editUBRAccount', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('submitSupplierData', res)
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 回显供应商信息
    createEvent(id) {
      this.dialogVisible = true
      if (id != 0) {
        this.getHttpServices().getServerApiService().get('ubr/getUBRAccountInfo?id=' + id).then(res => {
          if (res && res.id) {
            this.ruleForm = {
              ...res,
              merchantId: this.$store.getters.userInfo.merchantId,// 运营商ID ,
              platformId: this.getPlatformConfig().platformId
            }
          } else {
            this.$message.error('网络有误，请联系管理员')
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.ruleForm = {
          supplierName: '',
          appId: '',
          appKey: '',
          id: '',
          merchantId: this.$store.getters.userInfo.merchantId,// 运营商ID ,
          platformId: this.getPlatformConfig().platformId
        }
      }
    },
    // 操作
    handleEvent(id, status) {
      let text = status == 1 ? '启用' : '禁用'
      let that = this
      this.$confirm({
        title: '此操作将' + text + '该供应商?，是否继续',
        onOk() {
          that.getUpdateStatus(id)
        },
        onCancel() {
          that.$message.info('已取消')
        }
      })
    },
    // 查询状态
    getUpdateStatus(id) {
      let params = {
        id: id
      }
      this.getHttpServices().getServerApiService().post('ubr/updateUBRAccountStatus', params).then(res => {
        this.$message.success('操作成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    goRulesPage() {
      this.$router.push({
        name: 'UbrRules',
        query: {
          serverId: this.$route.query.serverId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    getColumns() {
      return [
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: 'appid',
          dataIndex: 'appId'
        },
        {
          title: 'appKey',
          dataIndex: 'appKey'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'statusSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '160px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped lang="less">
.right-box {
  text-align: right;
}
</style>